import z from "zod";

/**
 * EsqueceuSuaSenhaSchema
 */

export const EsqueceuSuaSenhaSchema = z.object({
  email: z.string().nonempty("Login inválido"),
});

/**
 * EsqueceuSuaSenhaForm
 */

export type EsqueceuSuaSenhaForm = z.infer<typeof EsqueceuSuaSenhaSchema>;